import {Children, cloneElement, isValidElement} from 'react'

export const childrenWithClonedProps = ({children, props, condition = true}) =>
  Children.map(children, child => {
    if (isValidElement(child) && condition) {
      return cloneElement(child, {...props, ...child.props})
    }
    return child
  })
